import { render } from "./practice-dialog.vue?vue&type=template&id=e6d921b6"
import script from "./practice-dialog.vue?vue&type=script&lang=js"
export * from "./practice-dialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__